import React from 'react';
import Helmet from 'react-helmet';

import Contact from 'src/components/contact';
import Features from 'src/components/features';
import Footer from 'src/components/footer';
import Header from 'src/components/header';
import Intro from 'src/components/intro';
import Testimonials from 'src/components/testimonials';

export default class Home extends React.Component {
	render() {
		return (
			<div>
				<Helmet title="Home" meta={[{ property: 'og:title', content: 'Home' }]} />
				<Header />
				<Intro />
				<Features />
				<Testimonials />
				<Contact />
				<Footer />
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/home.js